import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AlgoliaSearchService } from '@reusable/services/algolia.service';
import * as globals from '@reusable/services/globals';

@Injectable()
export class LookupService {
  responseData: any;

  constructor(private httpClient: HttpClient, private gtn: globals.GetTokenNow, private algoliaSearchService: AlgoliaSearchService) {}

  lookupOrders(search: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get<any>(`${globals.domain}/team/orders/lookup/${search}`, updateQueries);
  }

  lookupUsers(search: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get<any>(`${globals.domain}/team/users/lookup/${search}`, updateQueries);
  }

  lookupCars(car: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.post<any>(`${globals.domain}/cars/decode/`, { car }, updateQueries);
  }

  lookupReturnRequest(search: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get<any>(`${globals.domain}/team/return-requests/lookup/${search}`, updateQueries);
  }

  lookupPickRequests(search: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get<any>(`${globals.domain}/team/pick-requests/lookup/${search}`, updateQueries);
  }

  lookupPurchaseInvoices(search: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get<any>(`${globals.domain}/team/purchases-invoice/lookup/${search}`, updateQueries);
  }

  lookupCommissionsInvoice(search: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get<any>(`${globals.domain}/team/commissions-invoice/lookup/${search}`, updateQueries);
  }

  lookupHoldingCompanies(search: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get<any>(`${globals.domain}/team/holding-companies/lookup/${search}`, updateQueries);
  }

  lookupVendors(search: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get<any>(`${globals.domain}/team/vendors/lookup/${search}`, updateQueries);
  }

  lookupBranches(search: string, queries?) {
    const updateQueries = this.gtn.getHeaders();
    updateQueries['params'] = queries;
    return this.httpClient.get<any>(`${globals.domain}/team/branches/lookup/${search}`, updateQueries);
  }

  lookupAlgolia(search: string, q?) {
    console.log('got algolia');
    return this.algoliaSearchService.getHits(search);
  }
}